//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import { mapActions, mapGetters } from "vuex";
import SelectTemplate from "./SelectTemplate.vue";
import ContractDetails from "./ContractDetails.vue";
import ConfigurationTemplate from "./ConfigurationTemplate.vue";

export default {
    name: "UseTemplate",
    components: {
        SelectTemplate,
        ContractDetails,
        ConfigurationTemplate,
        AQButton,
        AQDialog
    },
    data() {
        return {
            currentStep: "select",
            selectedTemplate: {},
            dataDetails: null,
            dialogOpen: false,
            finishBtn: true,
            objectToSave: {},
            contractDetails: {},
            titleDialog: this.$t("smartContract.useTemplateSC.titleDialog"),
            messageDialog: this.$t("smartContract.useTemplateSC.messageDialog"),
            copyOfSelectedTemplate: {}
        };
    },
    computed: {
        ...mapGetters("main", ["getCurrentApplicationId"])
    },
    methods: {
        ...mapActions("smartContractDesigner", ["saveSmartContract", "importSmartContract", "getScCredentials", "getScNetworks"]),
        sendData(value) {
            this.selectedTemplate = JSON.parse(JSON.stringify(value));
            this.copyOfSelectedTemplate = JSON.parse(JSON.stringify(value));
            this.$refs.templateStepper.next();
        },
        backToCreateSmartContract() {
            this.$router.push("/smartContractList/newSmartContract");
        },
        backToSelectTemplate() {
            if (JSON.stringify(this.selectedTemplate) !== JSON.stringify(this.copyOfSelectedTemplate)) {
                this.dialogOpen = true;
            } else {
                this.$refs.templateStepper.previous();
            }
        },
        redirectToSmartList() {
            this.saveSmartContract(this.objectToSave).then(data => {
                if (data.status === 200) {
                    this.$router.push("/smartContractList");
                }
            });
        },
        okAction() {
            this.$refs.templateStepper.previous();
        },
        goToDetails(value) {
            const typeEth = "00000000-0000-0000-0000-000000000002";
            this.dataDetails = value;
            this.$refs.templateStepper.next();
            this.getScCredentials(typeEth);
            this.getScNetworks(typeEth);
        },
        colectData(value) {
            if (value.variable) {
                this.finishBtn = true;
            } else {
                this.finishBtn = false;
                this.contractDetails = value.object;
                this.objectToSave = this.prepareObjectForSave(this.dataDetails, value.object);
            }
        },
        prepareObjectForSave(object1, object2) {
            return {
                id: object2.id,
                applicationId: this.getCurrentApplicationId,
                name: object2.name,
                description: object2.description,
                address: object2.address,
                networkId: Array.isArray(object2.network) && object2.network[0] ? object2.network[0].value : object2.network,
                credentialsId: Array.isArray(object2.credentials) && object2.credentials[0] ? object2.credentials[0].value : object2.credentials,
                bcTypeId: Array.isArray(object2.type) ? object2.type[0].value : object2.type,
                template: {
                    description: object1.description,
                    id: object1.id,
                    name: object1.name,
                    walletIdentifier: object1.walletIdentifier,
                    contracts: object1.contracts
                }
            };
        },

        backToUseTemplate() {
            this.$refs.templateStepper.previous();
        }
    }

};
